import React, { useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { withTranslation } from "react-i18next";
import man from "assets/images/icons/Vectorpersonal-logo.svg";
import PersonalDetailedValue from "../PersonalDetailValue/PersonalDetailValue";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { BUSINESS_LINE_COLORS, BUSINESS_LINE_PATHS } from "helpers/utils";
import StyleWrapper from "./style";
import User from "assets/images/lead/user.svg";
import { ReactComponent as UPArrow } from "assets/images/lead/arrow-up-circle.svg";
import { ReactComponent as DownArrow } from "assets/images/lead/arrow-down-circle.svg";
import { ReactComponent as UserSmall } from "assets/images/lead/user-small.svg";
import { ReactComponent as CalendarIco } from "assets/images/lead/calendar.svg";
import { ReactComponent as IdCard } from "assets/images/lead/id-card.svg";


const LeadAccord = ({ customerDetails }) => {
  const handleAccordion = (bool) => {
    toggleAccordion(bool);
  };
  const [accordion, toggleAccordion] = useState(false);
  const { i18n } = useTranslation();
  const { businessLine } = useParams();

  return (
    <StyleWrapper>
      <div className="set-accord">
        <div className="reuse-accord">
          <Accordion
            onTabOpen={() => handleAccordion(true)}
            onTabClose={() => handleAccordion(false)}
          >
            <AccordionTab
              header={
                <React.Fragment>
                  <div className="flex-container p-2">
                    <React.Fragment>
                      <div className="header-flex">
                        <div className="header-Text">
                          <div className="head-icon">{<img src={User} alt="" />}</div>
                          <div className="welcome-text px-2">
                            <span>{i18n.t("PERSONAL_DETAIL.WELCOME")}, </span>
                            {i18n.language === "ar"
                              ? customerDetails?.araFirstName
                              : customerDetails?.engFirstName ?? "N/A"}
                          </div>
                        </div>
                        <div className="Icon-Div">
                          {accordion ?  <UPArrow /> :  <DownArrow />}
                        </div>
                      </div>
                    </React.Fragment>
                  </div>
                </React.Fragment>
              }
            >
              <div className="inner-content">
                <div className={"personal-details-head " + (i18n.language === 'ar' ? " ar" : "")}>
                  <div className="col-12">
                    <div className="row">
                      <div className="col-xs-12 col-md-4 mb-3">
                        <div className="username">
                          <UserSmall />
                          <p>{i18n.t("PERSONAL_DETAIL.NAME")}</p>
                        </div>
                        <div className="name">
                          <h4>
                            {i18n.language === "ar"
                              ? customerDetails?.araFullName ||
                                customerDetails?.araFirstName + " " + customerDetails?.araLastName
                              : customerDetails?.engFullName ||
                                customerDetails?.engFirstName + " " + customerDetails?.engLastName}
                          </h4>
                        </div>
                      </div>
                      <div className="col-xs-12 col-md-4 mb-3">
                        <div className="username">
                          <IdCard />
                          <p>{i18n.t("PERSONAL_DETAIL.ID_NUMBER")}</p>
                        </div>
                        <div className="name">
                          <h4 className="fm-tawuniya">{customerDetails?.idNumber ?? "N/A"}</h4>
                        </div>
                      </div>
                      <div className="col-xs-12 col-md-4">
                        <div className="username">
                          <CalendarIco />
                          <p>{i18n.t("PERSONAL_DETAIL.DOB")}</p>
                        </div>
                        <div className="name">
                          <h4 className="fm-tawuniya">
                            {customerDetails?.gregDob?.replace(/-/g, "/") ?? "N/A"}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </AccordionTab>
          </Accordion>
        </div>
      </div>
    </StyleWrapper>
  );
};
export default withTranslation()(LeadAccord);
